
import { 
  UserCheck, 
  Building2,
  ClipboardList,
  BarChart3,
  UserPlus
} from "lucide-react";
import type { MenuItem } from "../types";

export const clientsSection: MenuItem = {
  title: "العملاء",
  href: "#",
  icon: UserCheck,
  color: "from-indigo-500 to-indigo-600",
  permission: "العملاء",
  subItems: [
    {
      title: "إدارة العملاء",
      href: "/clients",
      icon: UserCheck,
      color: "from-indigo-500 to-indigo-600",
      permission: "العملاء",
    },
    {
      title: "العملاء المباشرين",
      href: "/clients/direct",
      icon: UserCheck,
      color: "from-green-500 to-green-600",
      permission: "العملاء",
    },
    {
      title: "العملاء المؤسسيين",
      href: "/clients/corporate",
      icon: Building2,
      color: "from-blue-500 to-blue-600",
      permission: "العملاء",
    },
    {
      title: "عملاء B2B",
      href: "/clients/b2b",
      icon: Building2,
      color: "from-purple-500 to-purple-600",
      permission: "العملاء",
    },
    {
      title: "متابعة العملاء",
      href: "/client-follow-up",
      icon: ClipboardList,
      color: "from-blue-500 to-blue-600",
      permission: "متابعة العملاء",
    },
    {
      title: "حالة العملاء",
      href: "/client-status",
      icon: BarChart3,
      color: "from-emerald-500 to-emerald-600",
      permission: "العملاء",
    },
    {
      title: "إدارة الحالات",
      href: "/client-status-management",
      icon: BarChart3,
      color: "from-purple-500 to-purple-600",
      permission: "إدارة حالات العملاء",
    },
    {
      title: "الشركات",
      href: "/companies",
      icon: Building2,
      color: "from-orange-500 to-orange-600",
      permission: "الشركات",
    },
    {
      title: "إدارة الشركات",
      href: "/company-management",
      icon: Building2,
      color: "from-purple-500 to-purple-600",
      permission: "إدارة الشركات",
    },
    {
      title: "عملاء Chatwoot",
      href: "/chatwoot-clients",
      icon: UserPlus,
      color: "from-cyan-500 to-cyan-600",
      permission: "عملاء Chatwoot",
    }
  ]
};
